import React from 'react'
// import material ui
import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import { BarChart } from '@mui/x-charts/BarChart';
// import i18n
import { useTranslation } from 'react-i18next';
// import components
import LinkTo from '../../../_components/LinkTo';
// import moment
import moment from 'moment';

const useStyles = makeStyles(theme => ({
    item: {
        paddingTop: 32,
        paddingBottom: 32,
        [theme.breakpoints.down(476)]: {
            paddingTop: 16,
            paddingBottom: 16,
        },
    },
    title_link: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 10,
    },

    chart: {
        width: "100%",
    },

    chartHover: {
        fill: "rgb(47, 128, 237)",
        transition: "0.5s",
        "&:hover": {
            fill: "#1F1F1F",
        },
    },
}));

const DashboardSales = (props) => {
    const { data, currency, notAllManagerDataCondition } = props;
    const { statistics } = data;
    const classes = useStyles();
    const { t } = useTranslation();
    const theme = useTheme();
    const staticData = [523, 1220, 1300, 200, 2500, 523, 1220, 1300, 200, 2500];

    const isTablet = useMediaQuery(theme.breakpoints.down(960), {
        defaultMatches: true,
    });

    return (
        <div className={`dashboard-card ${classes.item}`}>
            {notAllManagerDataCondition === true ? <div className="dashboard-card-empty">{t('common:fill_user_details_label')}</div> : statistics?.length < 10 ? (
                <div className="dashboard-card-empty">{t('common:cannot_show_chart_label')}</div>
            ) : null}
            <div className={classes.title_link}>
                <h2 className="dashboard-title">{t("common:schedule_of_sales_label")} <span style={{ fontWeight: 600 }}>({currency?.current_currency})</span></h2>
                <LinkTo title={"Розширений звіт"} adaptive={true} path={"/profile/invoice/"} />
            </div>
            <div className={classes.chart}>
                <BarChart
                    series={[{
                        id: 'auto-generated-id-0',
                        data: statistics?.length >= 10 ? statistics?.map((item) => item?.sum_sell) : staticData,
                        valueFormatter: (el) => `${currency?.current_symbol} ${el}`,
                    }]}
                    xAxis={[{
                        scaleType: 'band',
                        data: statistics?.length >= 10 ? statistics?.map((_, index) => index + 1) : staticData?.map((_, index) => index + 1),
                        valueFormatter: (el) => `${statistics?.length >= 10 ? moment(statistics[el - 1]?.data)?.format("DD.MM.YYYY") : el}`,
                    }]}
                    colors={["rgb(47, 128, 237)"]}
                    sx={{ width: '100%' }}
                    height={!isTablet ? 400 : 300}
                    slots={{
                        bar: (props) => {
                            const { style } = props;
                            const str = JSON.stringify(style);
                            const arr = JSON.parse(str);
                            const { x, y, height, width } = arr;

                            return <rect
                                className={`MuiBarElement-root MuiBarElement-series-auto-generated-id-0 css-trudc8-MuiBarElement-root ${classes.chartHover}`}
                                rx="20"
                                style={{
                                    transform: `translate3d(${x}px, ${y}px, 0px)`,
                                    width: `${width}px`,
                                    height: `${height}px`,
                                }}
                            ></rect>;
                        },
                    }}
                />
            </div>
        </div>
    )
}

export default DashboardSales